import { createFileRoute } from '@tanstack/react-router';

import { ProductionSettingsPage } from '../../../features/projects/ui/settings-page.tsx';
import { requireSettingsPermission } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/settings/production')({
  // Настройки производства видит только `projects.manage`; остальным раздел в меню не показывается.
  beforeLoad: requireSettingsPermission('projects.manage'),
  component: ProductionSettingsPage,
});
